import { render } from "./CollectionDateSelect.vue?vue&type=template&id=17a25348&scoped=true"
import script from "./CollectionDateSelect.vue?vue&type=script&lang=js"
export * from "./CollectionDateSelect.vue?vue&type=script&lang=js"

import "./CollectionDateSelect.vue?vue&type=style&index=0&id=17a25348&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a25348"]])

export default __exports__